
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10.45 10.45"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M5.61 5.23L10.37 10a.24.24 0 01.08.19.26.26 0 01-.08.2.24.24 0 01-.09.06H10.07a.24.24 0 01-.09-.06L5.23 5.61.47 10.37a.24.24 0 01-.09.06H.17a.24.24 0 01-.09-.06.3.3 0 01-.08-.2.27.27 0 01.08-.17l4.76-4.77L.08.47A.3.3 0 010 .27.27.27 0 01.08.08.28.28 0 01.28 0a.27.27 0 01.19.08l4.76 4.75L10 .08a.28.28 0 01.2-.08.27.27 0 01.19.08.24.24 0 01.08.19.26.26 0 01-.08.2z","data-name":"Layer 1"}})])])
          )
        }
      }
    